import * as React from "react";
import { SVGProps } from "react";

interface LogOutProps extends SVGProps<SVGSVGElement> {
    width?: string;
    height?: string;
}

export const LogOut = (props: LogOutProps): JSX.Element => (
    <svg
        width="800px"
        height="800px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        {...props}
    >
        <path
            stroke="#0c0c0c"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M22.5 4.742a13 13 0 11-13 0M16 3v10"
        />
    </svg>
);
